import React from "react";
import { useSelector } from "react-redux";
import { BsStar, BsStarFill } from "react-icons/bs";

import {
  TableContainer,
  TableHead,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
} from "../ui";
import {
  TableCard,
  TableCardHeader,
  TableCardTitle,
  AgentCell,
  AgentAvatar,
  AgentName,
  RatingDisplay,
  RatingValue,
  EmptyState,
  EmptyStateText,
} from "./AnalyticsTable.style";
import CONSTANTS from "../../const/constants";

const AnalyticsTable = ({ data = [] }) => {
  const companyId = useSelector((state) => state.user.data.company?.id);

  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.split(" ");
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const getAvatarColor = (name) => {
    const colors = [
      { bg: "#EEF2FF", text: "#4F46E5" },
      { bg: "#ECFDF5", text: "#059669" },
      { bg: "#FEF3C7", text: "#D97706" },
      { bg: "#FCE7F3", text: "#DB2777" },
      { bg: "#E0E7FF", text: "#4338CA" },
      { bg: "#CFFAFE", text: "#0891B2" },
    ];
    const index = name ? name.charCodeAt(0) % colors.length : 0;
    return colors[index];
  };

  const renderRating = (rating) => {
    const fullStars = Math.floor(rating);
    return (
      <RatingDisplay>
        {[...Array(5)].map((_, i) => (
          i < fullStars ? <BsStarFill key={i} /> : <BsStar key={i} style={{ color: '#D1D5DB' }} />
        ))}
        <RatingValue>{rating.toFixed(1)}</RatingValue>
      </RatingDisplay>
    );
  };

  if (!data || data.length === 0) {
    return (
      <TableCard>
        <TableCardHeader>
          <TableCardTitle>Rendimiento por Agente</TableCardTitle>
        </TableCardHeader>
        <EmptyState>
          <EmptyStateText>No hay datos de agentes disponibles</EmptyStateText>
        </EmptyState>
      </TableCard>
    );
  }

  return (
    <TableCard>
      <TableCardHeader>
        <TableCardTitle>Rendimiento por Agente</TableCardTitle>
      </TableCardHeader>
      <TableContainer>
        <TableHead>
          <tr>
            <TableHeaderCell>Agente</TableHeaderCell>
            <TableHeaderCell>Conv. Totales</TableHeaderCell>
            <TableHeaderCell>Respondidos</TableHeaderCell>
            <TableHeaderCell>Sin Responder</TableHeaderCell>
            <TableHeaderCell>Tiempo Resp. (min)</TableHeaderCell>
            <TableHeaderCell>Calificación</TableHeaderCell>
            {CONSTANTS.STATS_BOTS_ACTIVE.includes(companyId) && (
              <>
                <TableHeaderCell>Resp. Post-Asign. (min)</TableHeaderCell>
                <TableHeaderCell>Chats Bot</TableHeaderCell>
                <TableHeaderCell>Prom. Conv. (hrs)</TableHeaderCell>
              </>
            )}
          </tr>
        </TableHead>
        <TableBody>
          {data.map((agent, index) => {
            const avatarColor = getAvatarColor(agent.name);
            return (
              <TableRow key={agent.id || index}>
                <TableCell>
                  <AgentCell>
                    <AgentAvatar bgColor={avatarColor.bg} textColor={avatarColor.text}>
                      {agent.imageUrl ? (
                        <img src={agent.imageUrl} alt={agent.name} />
                      ) : (
                        getInitials(agent.name)
                      )}
                    </AgentAvatar>
                    <AgentName>{agent.name}</AgentName>
                  </AgentCell>
                </TableCell>
                <TableCell>{agent.totalMessages}</TableCell>
                <TableCell>{agent.answeredChats}</TableCell>
                <TableCell>{agent.unansweredChats}</TableCell>
                <TableCell>{Math.floor(agent.timeToResponse)}</TableCell>
                <TableCell>{renderRating(agent.rating || 0)}</TableCell>
                {CONSTANTS.STATS_BOTS_ACTIVE.includes(companyId) && (
                  <>
                    <TableCell>{agent.timeAfterAssignation || 0}</TableCell>
                    <TableCell>{agent.answeredChatsBot || 0}</TableCell>
                    <TableCell>{agent.averageServiceTime || 0}</TableCell>
                  </>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </TableContainer>
    </TableCard>
  );
};

export default AnalyticsTable;
